import { Button, Grid, TextField, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { PlannedQtyList } from './PlannedQtyList';
import { PlannedQtyDeviationList } from '../PlannedQtyDeviation/PlannedQtyDeviationList';
import { AssetDashboardSetting } from '../../types/app/asset.types';
import * as assetApi from '../../api/app/assetApi';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { Loader } from '../../components/core/Loader/Loader';
import { ApiError } from '../../components/core/ApiError/ApiError';
import { DesktopDatePicker } from '@mui/lab';
import { useTimezoneDialog } from '../../hooks/useTimezoneDialog';
import { Timezone, TimezoneChanger } from '../../components/app/TimezoneChanger/TimezoneChanger';
import moment, { Moment } from 'moment';
import { UserRoles } from '../../types/core/auth.types';
import { useAuth } from '../../contexts/authWindows';
import { useTranslation } from '../../contexts/translation';
import { useStyles } from './PlannedQtyForm.styles';

export function PlannedQtyPage() {
  const { id, name } = useParams();
  const { user } = useAuth();
  const { t } = useTranslation();
  const classes = useStyles();
  const isReadOnly =
    user?.roles.includes(UserRoles.Admin) || user?.roles.includes(UserRoles.Planning)
      ? false
      : true;

  const {
    timezone,
    isOpen: isTimezoneDialogOpen,
    setOpen: setTimezoneDialogOpen,
    setTimezone,
  } = useTimezoneDialog();

  const [filterDate, setFilterDate] = useState<Moment | null>(moment());
  const {
    data: settingData,
    isLoading: settingIsLoading,
    isError: settingIsError,
  } = useQuery<AssetDashboardSetting>(['settingForAsset', id], () =>
    assetApi.getMainDashBoardSettingForAsset(Number(id)),
  );

  // Otevírá okno pro výběr timezone
  const handleTimezoneOpen = () => {
    setTimezoneDialogOpen(true);
  };

  // Změna timezone
  const handleTimezoneChanged = (newTimezone: Timezone) => {
    setTimezone(newTimezone);
    setTimezoneDialogOpen(false);
  };

  const timezoneButton = (
    <Tooltip
      title={t('general.timezone.tooltip-timezone') ? t('general.timezone.tooltip-timezone') : ''}
    >
      <Button
        onClick={handleTimezoneOpen}
        style={{
          fontSize: '0.6rem',
          top: '12%',
          marginRight: '0.6rem',
        }}
      >
        {timezone.label}
      </Button>
    </Tooltip>
  );

  let headerButtons = [timezoneButton];

  if (settingIsError) return <ApiError />;
  if (settingIsLoading || !settingData) return <Loader />;

  return (
    <>
      <PageHeader
        title={t('page.dashboard.planned-qty.headline')}
        className={classes.header}
        buttons={headerButtons}
        itemTitle={name}
        itemClassName={classes.itemTitle}
      />
      <PageContent>
        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <TimezoneChanger
              isOpen={isTimezoneDialogOpen}
              timezone={timezone}
              onChange={handleTimezoneChanged}
              onClose={() => setTimezoneDialogOpen(false)}
            />
            <PlannedQtyList settingData={settingData} timezone={timezone} readOnly={isReadOnly} />
          </Grid>
          <Grid item xs={12} md={8}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <DesktopDatePicker
                  label={t('page.dashboard.planned-qty-deviation.input-date')}
                  value={filterDate}
                  //inputFormat={dateShowFormat}
                  onChange={(newValue: any) => {
                    setFilterDate(newValue);
                  }}
                  renderInput={(params: any) => <TextField {...params} />}
                />
              </Grid>
              <Grid item xs={12}>
                <PlannedQtyDeviationList
                  settingData={settingData}
                  dateFrom={filterDate}
                  timezone={timezone}
                  isReadOnly={isReadOnly}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
